import { render, staticRenderFns } from "./fileupdate.vue?vue&type=template&id=129b20cc&scoped=true"
import script from "./fileupdate.vue?vue&type=script&lang=js"
export * from "./fileupdate.vue?vue&type=script&lang=js"
import style0 from "./fileupdate.vue?vue&type=style&index=0&id=129b20cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129b20cc",
  null
  
)

export default component.exports